import store from '../../../store/index'
import notification from "./notification.vue";


window.IMC_NOTIFICATION =  new Vue({
    store,
    el: '#notification',
    name : "IMC_NOTIFICATION",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        notification
    }
});
